export default __webpack_public_path__ + "static/images/Nayeon_1_thumb.png";